import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// import "./index.css";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createStore } from "redux";
import dressReducer from "./reducers/dressReducer";
import { Provider } from "react-redux";
import { AuthProvider } from "./contexts/AuthProvider";

import { HelmetProvider } from "react-helmet-async";
// import reportWebVitals from "./reportWebVitals";
const store = createStore(dressReducer,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <HelmetProvider>
        <App />
        </HelmetProvider>
      </Provider>
    </QueryClientProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
